import { StyledOrderCardWrapper } from './styled';

const OrderCardWrapper = StyledOrderCardWrapper;

OrderCardWrapper.displayName = 'OrderCardWrapper';

export { OrderCardWrapper };
